export default __webpack_public_path__ + "static/media/botberry.66760bec.png";